import React, { useEffect } from 'react';
import TopNavigation from './TopNavigation';
import ClueRaiderBanner from './components/ClueRaiderBanner';
import { updatePageSEO } from './utils/seo';

const Privacy: React.FC = () => {
  useEffect(() => {
    updatePageSEO(
      'Privacy Policy - Dimension Flux',
      'Privacy policy for Dimension Flux. Learn how we collect and use data through Google Analytics and local browser storage for game statistics.'
    );
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      <TopNavigation />
      <ClueRaiderBanner />

      <div className="max-w-4xl mx-auto p-4 sm:p-6">
        <div className="bg-white bg-opacity-95 rounded-lg p-6 sm:p-8 border-2 border-gray-300 shadow-lg">
          <h1 className="text-2xl sm:text-3xl font-oswald font-bold text-gray-900 mb-6">Privacy Policy</h1>
          
          <div className="prose prose-gray max-w-none">
            <p className="text-gray-700 font-lora mb-4">
              <strong>Last updated:</strong> September 4, 2025
            </p>
            
            <h2 className="text-xl font-oswald font-bold text-gray-900 mt-6 mb-3">Information We Collect</h2>
            <p className="text-gray-700 font-lora mb-4">
              We use Google Analytics to understand how visitors interact with our game. This includes:
            </p>
            <ul className="list-disc list-inside text-gray-700 font-lora mb-4 space-y-2">
              <li>Pages visited and time spent on each page</li>
              <li>Device type and browser information</li>
              <li>General location (country/region level)</li>
              <li>Game completion statistics (stored locally in your browser)</li>
            </ul>
            
            <h2 className="text-xl font-oswald font-bold text-gray-900 mt-6 mb-3">How We Use Information</h2>
            <p className="text-gray-700 font-lora mb-4">
              We use this information to:
            </p>
            <ul className="list-disc list-inside text-gray-700 font-lora mb-4 space-y-2">
              <li>Improve the game experience</li>
              <li>Understand which features are most popular</li>
              <li>Fix technical issues</li>
              <li>Analyze game difficulty and completion rates</li>
            </ul>
            
            <h2 className="text-xl font-oswald font-bold text-gray-900 mt-6 mb-3">Data Storage</h2>
            <p className="text-gray-700 font-lora mb-4">
              Your game progress and statistics are stored locally in your browser. We do not store personal information on our servers.
            </p>
            
            <h2 className="text-xl font-oswald font-bold text-gray-900 mt-6 mb-3">Your Rights</h2>
            <p className="text-gray-700 font-lora mb-4">
              You can:
            </p>
            <ul className="list-disc list-inside text-gray-700 font-lora mb-4 space-y-2">
              <li>Decline analytics tracking when prompted</li>
              <li>Clear your browser data to remove local game statistics</li>
              <li>Use ad blockers to prevent tracking</li>
            </ul>
            
            <h2 className="text-xl font-oswald font-bold text-gray-900 mt-6 mb-3">Contact</h2>
            <p className="text-gray-700 font-lora mb-4">
              If you have questions about this privacy policy, please contact us through our website.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
